<template>
  <div class="money-list">
    <Row>
      <Col :xs="6" :sm="6" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            园区交易规模
            <Tooltip max-width="200" :content="tradeTip" placement="bottom">
              <Icon style="margin-left:5px" type="ios-help-circle-outline" />
            </Tooltip>
          </p>
          <p style="text-align: center;">￥{{orderData.ordertotalprice}}</p>
        </Card>
      </Col>
      <Col :xs="6" :sm="6" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            平台商城服务手续费({{orderData.parktotalprice.good_fx_bili}}%)
            <Tooltip max-width="200" :content="feeTip" placement="bottom">
              <Icon style="margin-left:5px" type="ios-help-circle-outline" />
            </Tooltip>
          </p>
          <p style="text-align: center;">{{orderData.parktotalprice.good_service_money}}</p>
        </Card>
      </Col>
      <Col :xs="6" :sm="6" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            平台云服务手续费({{orderData.parktotalprice.cloud_fx_bili}}%)
            <Tooltip max-width="200" :content="feeTip" placement="bottom">
              <Icon style="margin-left:5px" type="ios-help-circle-outline" />
            </Tooltip>
          </p>
          <p style="text-align: center;">{{orderData.parktotalprice.cloud_service_money}}</p>
        </Card>
      </Col>
      <Col :xs="6" :sm="6" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            园区账户余额
            <Tooltip max-width="200" :content="accountTip" placement="bottom">
              <Icon style="margin-left:5px" type="ios-help-circle-outline" />
            </Tooltip>
          </p>
          <p style="text-align: center;">
            ￥{{orderData.parktotalprice.parktotalprice}}
            <Button type="success" @click="toTixian">提现</Button>
          </p>
        </Card>
      </Col>
    </Row>
    <Row style="margin-top:20px">
      <Col :xs="6" :sm="6" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            园区余额
            <Tooltip content="Top Left text" placement="bottom">
              <Icon style="margin-left:5px" type="ios-help-circle-outline" />
            </Tooltip>
          </p>
          <p style="text-align: center;">￥{{orderData.parktotalprice.parkprice}}</p>
          <div class="action_back">
            <Button type="info" @click="toDetail">详情</Button>
            <Button type="success" @click="toTixian">提现</Button>
          </div>
        </Card>
      </Col>
      <Col :xs="6" :sm="6" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            商家余额
            <Tooltip content="Top Left text" placement="bottom">
              <Icon style="margin-left:5px" type="ios-help-circle-outline" />
            </Tooltip>
          </p>
          <p style="text-align: center;">￥{{orderData.parktotalprice.trad_money}}</p>
          <div class="action_back">
            <Button type="info" @click="toDetail">详情</Button>
            <Button type="success" @click="toTixian">提现</Button>
          </div>
        </Card>
      </Col>
      <Col :xs="6" :sm="6" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            一级分销商余额
            <Tooltip content="Top Left text" placement="bottom">
              <Icon style="margin-left:5px" type="ios-help-circle-outline" />
            </Tooltip>
          </p>
          <p style="text-align: center;">￥{{orderData.parktotalprice.firstagentprice}}</p>
          <div class="action_back">
            <Button type="info" @click="toDetail">详情</Button>
            <Button type="success" @click="toTixian">提现</Button>
          </div>
        </Card>
      </Col>
      <Col :xs="6" :sm="6" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            二级分销商余额
            <Tooltip content="Top Left text" placement="bottom">
              <Icon style="margin-left:5px" type="ios-help-circle-outline" />
            </Tooltip>
          </p>
          <p style="text-align: center;">￥{{orderData.parktotalprice.agentprice}}</p>
          <div class="action_back">
            <Button type="info" @click="toDetail">详情</Button>
            <Button type="success" @click="toTixian">提现</Button>
          </div>
        </Card>
      </Col>
    </Row>
    <Row>
      <Col span="6" style="padding-right:10px">
        <Form :model="todayItem" :label-width="100" style="margin-top:20px">
          <FormItem :label="todayTitle">
            <Select v-model="todayItem.select" @on-change="selectToday" default-label="当日">
              <Option :value="2">当年</Option>
              <Option :value="1">当月</Option>
              <Option :value="0">当日</Option>
            </Select>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Row>
      <Col :xs="8" :sm="8" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            园区总收入
            <!-- <Icon style="margin-left:5px" type="ios-help-circle-outline" /> -->
          </p>
          <p style="text-align: center;">￥{{toData.orderprice}}</p>
        </Card>
      </Col>
      <Col :xs="8" :sm="8" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            园区服务费
            <!-- <Icon style="margin-left:5px" type="ios-help-circle-outline" /> -->
          </p>
          <p style="text-align: center;">￥{{toData.parkprice}}</p>
        </Card>
      </Col>
      <Col :xs="8" :sm="8" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            商户收入
            <Icon style="margin-left:5px" type="ios-help-circle-outline" />
          </p>
          <p style="text-align: center;">￥{{toData.trad_money}}</p>
        </Card>
      </Col>
    </Row>
    <Row style="margin-top:20px">
      <Col :xs="8" :sm="8" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            一级分销商收入
            <Icon style="margin-left:5px" type="ios-help-circle-outline" />
          </p>
          <p style="text-align: center;">￥{{toData.firstagentprice}}</p>
        </Card>
      </Col>
      <Col :xs="8" :sm="8" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            二级分销商收入
            <Icon style="margin-left:5px" type="ios-help-circle-outline" />
          </p>
          <p style="text-align: center;">￥{{toData.agentprice}}</p>
        </Card>
      </Col>
      <Col :xs="8" :sm="8" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            平台手续费
            <Icon style="margin-left:5px" type="ios-help-circle-outline" />
          </p>
          <p style="text-align: center;">￥{{toData.plat_service_money}}</p>
        </Card>
      </Col>
    </Row>
    <Row>
      <Col span="20" style="padding-right:10px">
        <Form :model="timeItem" :label-width="80" style="margin-top:20px">
          <FormItem label="查询收入">
            <div class="date_back">
              <DatePicker
                type="datetimerange"
                placeholder="查询时间"
                confirm
                style="width: 300px"
                @on-ok="dateDone"
                @on-change="dateChange"
                @on-clear="dateClear"
              ></DatePicker>
              <Alert style="margin-left:10px" type="warning">此查询可能等待时间较长</Alert>
            </div>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Row>
      <Col :xs="8" :sm="8" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            园区总收入
            <!-- <Icon style="margin-left:5px" type="ios-help-circle-outline" /> -->
          </p>
          <p style="text-align: center;">￥{{dateData.orderprice}}</p>
        </Card>
      </Col>
      <Col :xs="8" :sm="8" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            园区服务费
            <!-- <Icon style="margin-left:5px" type="ios-help-circle-outline" /> -->
          </p>
          <p style="text-align: center;">￥{{dateData.parkprice}}</p>
        </Card>
      </Col>
      <Col :xs="8" :sm="8" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            商户收入
            <Icon style="margin-left:5px" type="ios-help-circle-outline" />
          </p>
          <p style="text-align: center;">￥{{dateData.trad_money}}</p>
        </Card>
      </Col>
    </Row>
    <Row style="margin-top:20px">
      <Col :xs="8" :sm="8" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            一级分销商收入
            <Icon style="margin-left:5px" type="ios-help-circle-outline" />
          </p>
          <p style="text-align: center;">￥{{dateData.firstagentprice}}</p>
        </Card>
      </Col>
      <Col :xs="8" :sm="8" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            二级分销商收入
            <Icon style="margin-left:5px" type="ios-help-circle-outline" />
          </p>
          <p style="text-align: center;">￥{{dateData.agentprice}}</p>
        </Card>
      </Col>
      <Col :xs="8" :sm="8" class="card_back">
        <Card class="card">
          <p slot="title" class="card_title">
            平台手续费
            <Icon style="margin-left:5px" type="ios-help-circle-outline" />
          </p>
          <p style="text-align: center;">￥{{dateData.plat_service_money}}</p>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "money-list",
  data() {
    return {
      orderData: {
        ordertotalprice: "-",
        parktotalprice: {
          parktotalprice: "-",
          parkprice: "-",
          trad_money: "-",
          firstagentprice: "-",
          agentprice: "-",
          on_fx: "-",
          underline_fx: "-"
        }
      },
      toData: {
        agentprice: "-",
        firstagentprice: "-",
        orderprice: "-",
        parkprice: "-",
        plat_service_money: "-",
        trad_money: "-"
      },
      dateData: {
        agentprice: "-",
        firstagentprice: "-",
        orderprice: "-",
        parkprice: "-",
        plat_service_money: "-",
        trad_money: "-"
      },
      todayItem: {
        select: 0
      },
      timeItem: {
        beginDate: null,
        endDate: null
      },
      todayTitle: "当日收入数据",
      tradeTip: "交易规模",
      accountTip: "园区账户余额",
      feeTip: "平台手续费"
    };
  },
  created: function() {
    this.id = this.$route.params.id;
    this.getOrderMoney();
    this.getDateData(1);
  },
  methods: {
    toDetail() {
      this.$router.push("/park/tc_record/" + this.id);
    },
    toTixian() {
      this.$router.push("/park/txlist/" + this.id);
    },
    selectToday(value) {
      if (value == "0") {
        this.todayTitle = "当日收入数据";
      } else if (value == "1") {
        this.todayTitle = "当月收入数据";
      } else if (value == "2") {
        this.todayTitle = "当年收入数据";
      }
      // this.todayItem.select = value
      this.getDateData(1);
    },
    dateChange(dates) {
      if (dates && dates.length > 1) {
        this.timeItem.beginDate = dates[0];
        this.timeItem.endDate = dates[1];
      }
    },
    dateDone() {
      this.getDateData(2);
    },
    dateClear() {
      this.dateData = {
        agentprice: "-",
        firstagentprice: "-",
        orderprice: "-",
        parkprice: "-",
        plat_service_money: "-",
        trad_money: "-"
      };
    },
    getOrderMoney() {
      this.$api.parkmoneylog.ordermoney({ park_uuid: this.id }).then(res => {
        if (res.code == 200) {
          this.orderData = res.result;
        }
      });
    },
    getDateData(type) {
      var that = this;
      var params = {
        type: type, // 1统计当前2统计时间段
        park_uuid: this.id
      };
      if (type == 1) {
        params.todaytype = this.todayItem.select;
      } else {
        params.startdate = this.timeItem.beginDate;
        params.enddate = this.timeItem.endDate;
      }
      this.$api.parkmoneylog.todaymoney(params).then(res => {
        if (res.code == 200) {
          if (type == 1) {
            that.toData = res.result;
          } else if (type == 2) {
            that.dateData = res.result;
          }
        }
      });
    }
  }
};
</script>
<style scoped>
.card_back {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* width:350px; */
}
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 250px;
}
.card_title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
}
.action_back {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 200px;
}
.date_back {
  display: flex;
}
</style>
